import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CartService } from '../../shared-core/services/cart.service';

@Component({
  selector: 'app-promotion',
  templateUrl: './promotion.component.html',
  styleUrls: ['./promotion.component.scss']
})
export class PromotionComponent implements OnInit {

  constructor(public service: CartService) {  }

  ngOnInit(): void {
  }

  onSubmit(form: NgForm) {
    this.service.postCartPromotion().subscribe(
      res => {
       //TODO: What to do with promotion form: Disable or reset? 
      },
      err => { console.log(err); }
    );
  }

}
